export default __webpack_public_path__ + "static/flyer-wsg-5791b0cd07c99fc3f0ec0d4331abc686.jpg";